import { useEffect } from "react";
import { trackVisitor } from "../services/visitorService";

export function useVisitorTracking() {
    useEffect(() => {
        trackVisitor();
    }, []);
}
